//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DiamondsPopover from "@/components/DiamondsPopover";
export default {
  components: { DiamondsPopover },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    toShopPage() {
      this.$emit("shop");
    },
    onDetailClick() {
      this.$emit("change");
    },
  },
};
